import { render, staticRenderFns } from "./Moneda.vue?vue&type=template&id=248ca41c&"
import script from "./Moneda.vue?vue&type=script&lang=js&"
export * from "./Moneda.vue?vue&type=script&lang=js&"
import style0 from "./Moneda.vue?vue&type=style&index=0&id=248ca41c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports